import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";
import {ROLE_STUDENT, ROLE_TEACHER} from "../../common/roles";

export const AUTH = "auth";

export const LOGOUT_URL = "/logout-user";

export const login = createAsyncThunk(
    `${AUTH}/login`,
    async (body) => {
        const response = await client.post('/login', body)
        return response.data
    }
)

export const isAuthenticated = createAsyncThunk(
    `${AUTH}/isAuthenticated`,
    async () => {
        const response = await client.get('/isAuthenticated')
        return response.data
    }
)

export const logout = createAsyncThunk(
    `${AUTH}/logout`,
    async () => {
        const response = await client.get(LOGOUT_URL)
        return response.data
    }
)

export const getNextLesson = createAsyncThunk(
    `${AUTH}/getNextLesson`,
    async () => {
        const response = await client.get('/lesson/getNextLesson')
        return response.data
    }
)

export const sendImage = createAsyncThunk(
    `${AUTH}/sendImage`,
    async (body) => {
        const response = await client.post('/user/saveImg', body)
        return response.data
    }
)

// ROLE IS IMPORTANT
export const updateUser = createAsyncThunk(
    `${AUTH}/updateUser`,
    async (body) => {
        let link = '';
        if (body.role === ROLE_STUDENT) {
            link = '/student/update'
        }
        if (body.role === ROLE_TEACHER) {
            link = '/teacher/update'
        }
        const response = await client.post(link, body)
        return response.data
    }
)
export const updateUserAdditional = createAsyncThunk(
    `${AUTH}/updateUserAdditional`,
    async (body) => {
        const response = await client.post('/teacher/updateAdditional', body)
        return response.data
    }
)
export const recoveryPassword = createAsyncThunk(
    `${AUTH}/recoveryPassword`,
    async (body) => {
        const response = await client.post('/recoveryPassword', body)
        return response.data
    }
)
export const acceptRecoveryPassword = createAsyncThunk(
    `${AUTH}/acceptRecoveryPassword`,
    async (body) => {
        const response = await client.get(`/recoveryPassword/${body.id}/${body.uuid}/accept`)
        return response.data
    }
)